<template>
  <nuxt-link
    active-class="border-black"
    class="wrapper group grid h-full grid-cols-[auto_min-content] items-center gap-2 rounded-lg border bg-white p-2 pr-3 text-sm font-semibold transition active:scale-95"
    :to="to"
  >
    <div class="prepend h-10 w-10 shrink-0">
      <slot name="prepend" />
    </div>

    <span
      class="label"
      :class="{ 'whitespace-nowrap': label.length < 15 }"
      v-html="formattedLabel"
    />
  </nuxt-link>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

import type { RouteLocationRaw } from "#vue-router";

const properties = defineProps<{
  label: I18nMessage;
  to: RouteLocationRaw;
}>();

const formattedLabel = computed(() =>
  properties.label.replaceAll(/(& |\/ )/g, "&&nbsp;"),
);
</script>

<style scoped>
@supports (animation-timeline: scroll()) {
  @keyframes prependTransition {
    to {
      height: theme("spacing.8");
      width: theme("spacing.8");
    }
  }

  @keyframes wrapperTransition {
    to {
      padding-top: theme("spacing.1");
      padding-bottom: theme("spacing.1");
    }
  }

  @keyframes labelTransition {
    to {
      font-size: theme("fontSize.xs");
    }
  }

  .prepend,
  .label,
  .wrapper {
    animation-fill-mode: both;
    animation-timing-function: ease-in-out;
    animation-timeline: scroll(root);
    animation-range: 0 100px;
  }

  .prepend {
    animation-name: prependTransition;
  }

  .wrapper {
    animation-name: wrapperTransition;
  }

  .label {
    animation-name: labelTransition;
  }
}
</style>
